export const chatFiltersNames = [
    {
        label:"All",
        value:"all",
    },
    {
        label:"Unread",
        value:'unread',
    }
]